import { createSelector } from 'reselect';

import { ChatWidgetStore, ChatWidgetStoreState } from './typings';

const storeStateSelector = <T extends ChatWidgetStore>(storeState: T): ChatWidgetStoreState => storeState.chatWidget;

export const getIsChatWidgetVisible = createSelector([storeStateSelector], (state): boolean => {
    return state.isVisible;
});

export const getUnreadCount = createSelector([storeStateSelector], (state): number => {
    return state.unreadCount;
});
